import * as z from 'zod';

import { fileQuerySchema } from '@/_schemas/file';

import { statusQuerySchema } from '../status-input/schema';

export const countryQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
  short_name: z.string().nullable(),
  capital_city: z.string().nullable(),
  abbreviation: z.string().nullable(),
  continent_abbreviation: z.string().nullable(),
  continent_name: z.string().nullable(),
});

export type CountryQueryLinkerSchema = z.infer<typeof countryQueryLinkerSchema>;

export const countryQuerySchema = countryQueryLinkerSchema.extend({
  currency_name: z.string().nullable(),
  calling_code: z.string(),
  phone_format: z.string(),
  status: statusQuerySchema,
  flag_id: z.number().nullable(),
  flag: fileQuerySchema.nullish(),
  tld: z.string().nullable(),
});

export type CountryQuerySchema = z.infer<typeof countryQuerySchema>;

export const defaultCountry: Readonly<CountryQuerySchema> = {
  id: -1,
  name: '',
  short_name: '',
  capital_city: '',
  calling_code: '',
  phone_format: '',
  status: '',
  abbreviation: '',
  flag_id: -1,
  flag: null,
  continent_abbreviation: '',
  currency_name: '',
  continent_name: '',
  tld: '',
} as const;
